export default {
    instagram: 'https://www.instagram.com/getcampfire/',
    linkedin: 'https://www.linkedin.com/company/getcampfire'
}